module.exports = __webpack_public_path__ + "img/qbc-exhibitors@2x.5db7c89f.png";